import { useAppSelector } from '@frontend/common';
import { EquipmentGroupConstraintData, isEquipmentGroupConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { EquipmentGroupConstraintDataInputProps } from './equipment-group-constraint-data-input.component';

interface ViewProps {
    formValues: EquipmentGroupConstraintData;
}

const useEquipmentGroupConstraintDataInput = (props: EquipmentGroupConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isEquipmentGroupConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { equipment_group_id: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useEquipmentGroupConstraintDataInput;
